export const getRandomNumber = (min = 0, max = 10) =>
  Math.floor(Math.random() * (max - min + 1) + min);

export const pickOne = arr => arr[getRandomNumber(0, arr.length - 1)];

// Generates Random chart data for labels passed in
export const getDataForLabels = (labels, min = 0, max = 5) =>
  labels.map(x => [x, getRandomNumber(min, max)]);



// WEBPACK FOOTER //
// ./src/helpers/random.js